import { useEffect, useRef, useState } from 'react';
import { validateDomain as validEmailDomain, validateEmail } from "@/utils/validate-email";
import PropTypes from 'prop-types';
import api from '@/services/api/userManagement.js';
import Loader from '@/componentsDS/Loader/Loader';
import { ReactComponent as IconInfoDynamicFill } from '@/assets/svgs/information-circle-dynamic-fill.svg';


const DEBOUNCE_DELAY = 500
const MultipleEmailAddressInput = ({email, setEmail,  emailList, setEmailList, emailText, isEdit, validateExistingEmail, isTypesEmailValid, setIsTypedEmailValid }) => {

    const [loading, setLoading] = useState(false);
	const  [errorMsg, setErrorMsg] = useState("")
	const emailRef = useRef(email)
	const debounceTimeout = useRef(null)



	// Handler Functions
	const validateEmailAsync = async (typedEmail) => {
		if (!validateEmail(typedEmail)) {
			setIsTypedEmailValid(false);
			setErrorMsg("Please enter a valid Email Address");
			return;
		}

		if (!validEmailDomain(typedEmail)) {
			setIsTypedEmailValid(false);
			setErrorMsg("The following domains are not allowed to be registered");
			return;
		}

		setLoading(true);
		const [error, response] = await api.checkUser(emailRef.current);
		setLoading(false);

		if (error) {
			setIsTypedEmailValid(false);
			setErrorMsg("Failed to verify email, please try again");
		} else if (response) {
			setIsTypedEmailValid(false);
			setErrorMsg("This email already exists. Please directly choose the organisation from the list.");
		} else {
			setIsTypedEmailValid(true);
			setErrorMsg("");
		}
	};

	const handleEmailChange =async (e) => {
		e.preventDefault()
		if(loading) return
		const newEmail = e.target.value
		setEmail(newEmail)
		emailRef.current = newEmail
	}

	const handleChip =(e)=>{
		if(e.key === 'Enter') {
			e.preventDefault();

			     if (!validateEmail(email)) {
					setIsTypedEmailValid(false);
					setErrorMsg("Please enter a valid Email Address")
                return ;
            }
            if (!validEmailDomain(email)) {
				setIsTypedEmailValid(false);
				setErrorMsg("The following domain are not allowed to be Registered");
				return ;
            }
			setIsTypedEmailValid(true);
			setErrorMsg("");
			isEdit ? setEmailList([email]) : setEmailList([...emailList, email]);
			setEmail('');
		}
	}

	const removeEmail = (emailToRemove) => {
        setEmailList(emailList.filter((emailItem) => emailItem !== emailToRemove));
		emailRef.current = ''
    };

	//USE EFFECTS
	useEffect(() => {
		if (isEdit && emailList.length > 0) {
			setEmail(emailList[0]);
		}
	}, [emailList]);

	useEffect(() => {
		if (!validateExistingEmail || !email) {
			setIsTypedEmailValid(false);
			return;
		}

		// Clear previous timeout
		clearTimeout(debounceTimeout.current);

		debounceTimeout.current = setTimeout(() => {
			validateEmailAsync(email);
		}, DEBOUNCE_DELAY);

		return () => clearTimeout(debounceTimeout.current);
	}, [email, validateExistingEmail]);

    return (<>
        <div className='card-configure__body__desc'>
            <div>{emailText}</div>
            <div>Send your email invites here:</div>
        </div>
        <div className="card-configure__body__dropdown">
            <span className="card-configure__body__dropdown__title">
                Email Address
            </span>
            <div className="card-configure__body__email-input-container">
                {!isEdit && <div className="card-configure__body__email-tags">
                    {emailList?.map((email) => (
                        <div key={email} className="email-tag">
                            {email}
                            <span className="remove-icon" onClick={() => removeEmail(email)} role="none">
                                &times;
                            </span>
                        </div>
                    ))}
                </div>}
                <textarea
                    rows={1}
                    type="text"
                    value={email}
                    onChange={(e) => handleEmailChange(e)}
                    onKeyDown={handleChip}
                    placeholder="Enter Email Address"
                />
                {loading && <div className='notification-list__loader-icon'><Loader /></div>}
            </div>
			{errorMsg && <div className="card-configure__body__dropdown__title card-configure__body__dropdown__title--info text--asterisk">
				<IconInfoDynamicFill className='card-configure__body__dropdown__with-icon-image' />
				{errorMsg}
			</div>}

        </div>
    </>)
}

MultipleEmailAddressInput.propTypes = {
    emailList: PropTypes.array,
    setEmailList: PropTypes.func,
    emailText: PropTypes.string,
    isEdit: PropTypes.bool,
    validateExistingEmail: PropTypes.bool
}

export default MultipleEmailAddressInput;
